import React, { Component } from 'react';
import View from 'react-flexbox'
import { Button, Divider, Typography } from '@material-ui/core'
import Kamban from "../KambamComponent";
import { DialogPesquisa } from "scorpion-core";
import DinamicCrudCustomFormDialog from "../../../../../DinamicForms/components/DinamicCrudCustomFormDialog";


class ViewFluxoKamban extends Component {

    constructor(props) {
        super(props);
        this.updateItens = this.updateItens.bind(this);
        this.renderItem = this.renderItem.bind(this);
        this.state = { itemEditar: null }

    }
    componentDidMount() {

        this.props.listar(this.props.customForm);

    }
    updateItens(lista) {
        const { propOrdem, propTipo, listaItens } = this.props


        lista.forEach((item, index) => {
            let itemOriginal = listaItens[index];
            let compareJSON = this.compareJSON(itemOriginal, item)
            if (item[propTipo] === '.') {
                item[propTipo] = null;
            }


            if (compareJSON && item[propOrdem] !== undefined) {
                // console.log('item de', itemOriginal);
                // console.log('item p/', item);
                // console.log('compare', compareJSON);
                // console.log('compare ant', this.compareJSON(item, itemOriginal));


                let props = {}
                props.uid = item.uid
                props[propOrdem] = item[propOrdem]
                props[propTipo] = item[propTipo]


                // console.log('props', props);

                this.salva(props)
            }
        });

    }
    salva(props) {
        this.props.salvarItem(this.props.customForm, props)
    }
    compareJSON(obj1, obj2) {
        var ret = {};
        for (var i in obj2) {
            if (!obj1.hasOwnProperty(i) || obj2[i] !== obj1[i]) {
                ret[i] = obj2[i];
            }
        }
        return ret;
    };
    renderItem(item, style, fase) {

        let fieldKanban = this.props.fieldKanban
        if (!fieldKanban) {
            return "Sem field configurado"
        }
        //<Typography style={{ fontWeight: 900 }}>{getLabel(this.props.customForm, v)}</Typography>
        let values = fieldKanban.split(",").map((v, index) => <View key={index} column><Typography>{item[v]}</Typography></View>)
        let valuesfieldInferior = "";




        let funcSecundario = null;
        if (this.props.confFluxo.codeSecundario) {
            funcSecundario = new Function("return " + this.props.confFluxo.codeSecundario)();
            let vr = funcSecundario(item, fase)
            if (vr) {
                valuesfieldInferior = vr;
            }
        }
        if (typeof valuesfieldInferior == 'string') {
            valuesfieldInferior = <View column><Typography>{valuesfieldInferior}</Typography></View>
        }




        return <View column>
            <View column>
                {/* {item[this.props.fieldKanban]} */}
                {values}

            </View>
            <Divider />
            <View style={{ justifyContent: 'flex-end', padding: 5 }}>
                {valuesfieldInferior}

                <Button variant="contained" color="secondary" size="small" onClick={() => {
                    // this.props.history.push({
                    //     pathname: this.props.rota,
                    //     state: { uidItem: item.uid }
                    // })
                    this.setState({ itemEditar: item }, () => this.dialog.show())

                }}>Ver</Button>
            </View>

        </View>
    }
    render() {
        const { listaTipos, listaItens, propOrdem, propOrdemAux, propTipo } = this.props
        const { itemEditar } = this.state

        return (<View>

            <Kamban listaTipos={listaTipos} listaItens={JSON.parse(JSON.stringify(listaItens))} propOrdem={propOrdem} propOrdemAux={propOrdemAux} propTipo={propTipo} updateLista={this.updateItens} renderItem={this.renderItem} />
            <DialogPesquisa forwardedRef={node => this.dialog = node} >
                <DinamicCrudCustomFormDialog initialValues={itemEditar} sair={() => {this.dialog.hide();}} customFormUid={this.props.customForm.uid} />
            </DialogPesquisa>
        </View>

        );
    }
}

export default ViewFluxoKamban;



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/FluxoKamban/components/ViewFluxoKamban/ViewFluxoKamban.js